import {
  Box,
  Divider,
  Typography,
  Icon,
  useMediaQuery,
  Grid,
} from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import i18n from 'lib/i18'
import theme from 'lib/theme'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useAuth } from 'providers/AuthProvider'
import { LocalMall, Map } from '@mui/icons-material'
import { ReactComponent as Place } from 'assets/images/icon-place.svg'
import { ReactComponent as DashboardImg } from 'assets/images/dashboard-img.svg'
import { ReactComponent as Product } from 'assets/images/icon-product.svg'
import versionJson from '../../VERSION.json'

enum SIDEBARROUTES {
  PRODUCT = '/product',
  ORDER = '/order',
  ROUTE = '/route',
  PLACE = '/place',
}

const Home = () => {
  const { userRoles } = useAuth()
  const { t } = useTranslation()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const date = new Date().toLocaleString(i18n.language, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
  const formattedDate = date.charAt(0).toUpperCase() + date.slice(1)
  const navigationBoxes = {
    ORDER: {
      title: t('orders'),
      description: t('orderDescription'),
      path: '/order',
      Icon: LocalMall,
    },
    PRODUCT: {
      title: t('product'),
      description: t('productDescription'),
      path: '/product',
      Icon: Product,
    },
    ROUTE: {
      title: t('routes'),
      description: t('routeDescription'),
      path: '/route',
      Icon: Map,
    },
    PLACE: {
      title: t('places'),
      description: t('placeDescription'),
      path: '/place',
      Icon: Place,
    },
  }

  const linksArray = Object.keys(SIDEBARROUTES).filter((route) =>
    userRoles.includes(route.toLowerCase())
  ) as Array<keyof typeof SIDEBARROUTES>

  return (
    <Box
      display='flex'
      height={isMobile ? '' : '100vh'}
      justifyContent='space-between'
      flexDirection='column'>
      <Box p={4} width={isMobile ? '100%' : '80%'}>
        <Box
          display={isMobile ? 'block' : 'flex'}
          justifyContent='space-between'
          mb={1}>
          <Box>
            <Typography sx={{ color: theme.palette.text.secondary }}>
              {formattedDate}
            </Typography>
            <Typography
              variant='h1'
              sx={{
                padding: isMobile
                  ? `${theme.spacing(3)} 0`
                  : `${theme.spacing(7)} 0`,
              }}>
              {t('welcomeToNaveo')}
            </Typography>
          </Box>
          <DashboardImg
            style={{
              flexBasis: isMobile ? '100%' : '616px',
              height: isMobile ? '200px' : '',
            }}
          />
        </Box>
        <Divider />
        <Typography
          sx={{
            color: theme.palette.text.secondary,
            fontWeight: 'bold',
            fontSize: '10px',
            padding: `${theme.spacing(2)} 0`,
            marginBottom: theme.spacing(1),
          }}>
          {t('availableCategories').toUpperCase()}
        </Typography>
        <Grid container columnSpacing={1}>
          {linksArray.map((item) => (
            <Grid item key={item} md={3} xs={6}>
              <Link
                to={navigationBoxes[item].path}
                style={{
                  alignSelf: 'flex-end',
                  textDecoration: 'none',
                  color: theme.palette.commonColors.black,
                }}>
                <Box
                  height='166px'
                  flex-direction='column'
                  p={2}
                  mb={2}
                  sx={{
                    backgroundColor: theme.palette.action.selected,
                    position: 'relative',
                  }}>
                  <Box>
                    <Box display='flex' alignItems='center'>
                      <Icon
                        component={navigationBoxes[item].Icon}
                        sx={{
                          '*': {
                            fill: theme.palette.primary.main,
                            color: theme.palette.primary.main,
                          },
                          fill: theme.palette.primary.main,
                          color: theme.palette.primary.main,
                          width: '20px',
                          height: '20px',
                          marginRight: theme.spacing(0.5),
                          '&:hover': {
                            fill: theme.palette.primary.main,
                            '*': {
                              fill: theme.palette.primary.main,
                            },
                          },
                        }}
                      />
                      <Typography
                        variant='h3'
                        sx={{
                          color: theme.palette.primary.main,
                          fontWeight: 'bold',
                          fontSize: '12px',
                        }}>
                        {navigationBoxes[item].title}
                      </Typography>
                    </Box>
                    <Typography mt={2} mb={2}>
                      {navigationBoxes[item].description}
                    </Typography>
                  </Box>
                  <ArrowForwardIcon
                    sx={{
                      right: theme.spacing(2),
                      bottom: theme.spacing(2),
                      position: 'absolute',
                    }}
                  />
                </Box>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Typography
        mb={2}
        sx={{
          color: theme.palette.text.secondary,
          textAlign: 'center',
        }}>
        Naveo Commerce Ltd. © 2022 | version: {versionJson.version}
      </Typography>
    </Box>
  )
}
export default Home
